import Axios from "axios";

export type VisitOnlyRejectPayload = {
  visitId: number;
  reason?: string;
};

/** POST visitor registration actions (visit id = place booking id). */
export const postVisitOnlyCheckIn = (visitId: number) =>
  Axios.post(`/booking/visit-only/${visitId}/check-in`);

export const postVisitOnlyCheckOut = (visitId: number) =>
  Axios.post(`/booking/visit-only/${visitId}/check-out`);

export const postVisitOnlyReject = (visitId: number, body?: { reason?: string }) =>
  Axios.post(`/booking/visit-only/${visitId}/reject`, body);
